import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import type {AppState} from '@stores/AppState';
import type {AuditQuestionsEditBuffer} from '../../../../stores/audit/AuditQuestionsEditBuffer';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {DeleteIcon} from '../../../components/icons/DeleteIcon';
import {DuplicateIcon} from '../../../components/icons/DuplicateIcon';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface AuditQuestionOptionsProps extends ContextMenuInterface {
    questionId: string;
    buffer: AuditQuestionsEditBuffer;
}

export const openAuditQuestionOptions = (
    appState: AppState,
    questionId: string,
    buffer: AuditQuestionsEditBuffer,
    event: React.MouseEvent,
) => {
    appState.setContextMenu({
        id: `audit-question-options-${questionId}`,
        type: 'audit-question-options',
        clientX: event.clientX,
        clientY: event.clientY,
        withOverlay: true,
        minWidth: 180,
        params: {questionId, buffer},
    });
};

export const AuditQuestionOptions = observer(({handleClose, isDark, questionId, buffer}: AuditQuestionOptionsProps) => {
    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    text: intl.get('common.duplicate').d('Duplicate'),
                    Icon: DuplicateIcon,
                    onClick: () => {
                        buffer.duplicateQuestion(questionId);
                        handleClose();
                        return false;
                    },
                },
                {
                    text: intl.get('common.delete').d('Delete'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        buffer.deleteQuestion(questionId);
                        handleClose();
                        return false;
                    },
                },
            ]}
        />
    );
});
